import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';

export default class RecycleBulkFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: null,
            end_date: null,
            customer_ids: '',
        };
    }

    getDownloadUrl = () => {
        const params = new URLSearchParams();

        if (this.state.customer_ids) {
            params.append('customer_ids', this.state.customer_ids);
        }

        if (this.state.date) {
            params.append('date', moment(this.state.date).format('YYYY/MM/DD'));
        }

        if (this.state.end_date) {
            params.append('end_date', moment(this.state.end_date).format('YYYY/MM/DD'));
        }

        return this.props.reportRoute + '?' + params.toString();
    };

    render() {
        return (
            <>
                <div className="row">
                    <div className="col-md-4 form-group">
                        <label className="text-uppercase">Start Month</label>
                        <DatePicker
                            selected={this.state.date}
                            onChange={(date) => this.setState({ date })}
                            showMonthYearPicker
                            showFullMonthYearPicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Select month"
                        />
                    </div>

                    <div className="col-md-4 form-group">
                        <label className="text-uppercase">End Month (inclusive)</label>
                        <DatePicker
                            selected={this.state.end_date}
                            onChange={(date) => this.setState({ end_date: date })}
                            showMonthYearPicker
                            showFullMonthYearPicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            placeholderText="Select month"
                        />
                    </div>
                     <div className="col-md-4 form-group">
                        <a
                            href={this.getDownloadUrl()}
                            className="btn btn-cw-primary"
                        >
                            Download Reports
                        </a>
                    </div>
                </div>
            </>
        );
    }
}

if (document.getElementById('recycle-bulk-filter')) {
    const element = document.getElementById('recycle-bulk-filter');

    ReactDOM.render(
        <RecycleBulkFilter reportRoute={element.dataset.report_route} />,
        element
    );
}